<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 21 21"
  >
    <g>
      <path
        :fill="color"
        d="M14.089 12.898a.421.421 0 0 1 0 .595l-.596.596a.421.421 0 0 1-.595 0L10 11.19 7.102 14.09a.421.421 0 0 1-.595 0l-.596-.596a.421.421 0 0 1 0-.595L8.81 10 5.91 7.102a.421.421 0 0 1 0-.595l.596-.596a.421.421 0 0 1 .595 0L10 8.81l2.898-2.898a.421.421 0 0 1 .595 0l.596.596a.421.421 0 0 1 0 .595L11.19 10zM10.054.467C4.512.467 0 4.977 0 10.52c0 5.544 4.51 10.055 10.055 10.055 5.544 0 10.054-4.51 10.054-10.055C20.11 4.977 15.6.467 10.055.467z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#F31357',
    },
    size: {
      type: Number,
      default: 21,
    },
  },
};
</script>
